module Meevo.Plugins.AlertsManager {

    import IAlertJSON = Meevo.Model.IAlertJSON;

    export interface IBaseConfigComponent {
        params: IParams;
        data?: Object;
        dataForReview: string[] | number[] | _.Dictionary<any>[]; // use this to render result in the review-settings-tab.component
        alertConfiguration?: Object; // use this to set the alert configuration which would be uploaded to the server

        onEdit(alertJson: IAlertJSON): void;
    }

    const DEFAULT_DATA: ISingleMoverData = {
        label: '',
        configKey: '',
        choicesToShow: [],
        identifier: 'id',
        showAll: false,
        name: '',
        moverTemplate: ''
    };

    export abstract class BaseConfigComponent implements IBaseConfigComponent, ng.IComponentController {

        abstract params: IParams;
        abstract data: ISingleMoverData;

        dataForReviewTemplate: string;

        abstract get dataForReview(): string[] | number[] | _.Dictionary<any>[];  // use this to render result in the review-settings-tab.component

        abstract get alertConfiguration(): Object;  // use this to set the alert configuration which would be uploaded to the server

        constructor(protected alertsManagerService: IAlertsManagerService) {
            Object.defineProperties(this.params, {
                dataForReview: {
                    get: () => this.dataForReview
                },
                alertConfigurations: {
                    get: () => this.alertConfiguration
                }
            });
        }

        /**
         * NOTICE: Don't forget to call super.$onInit() method if you override this method in your class
         */
        $onInit() {
            this.params.dataForReviewTemplate = this.dataForReviewTemplate;
            this.data = _.extend({}, DEFAULT_DATA, this.data);
            this.dataForReview.length = 0;

            if (this.alertsManagerService.alert) {
                let alertJson: IAlertJSON = <IAlertJSON>{};
                try {
                    alertJson = JSON.parse(this.alertsManagerService.alert.alertJSON);
                } catch (e) {
                }

                this.onEdit(alertJson);
            }
        }

        $onDestroy(): void {
            this.dataForReview.length = 0;

            Object.defineProperties(this.params, {
                dataForReview: {
                    get: () => []
                },
                alertConfigurations: {
                    get: () => null
                }
            });

            this.params.dataForReviewTemplate = null;
        }

        /**
         * Use this method to apply data from the alert model in to the components model
         */
        abstract onEdit(alertJson: IAlertJSON): void;

    }
}
